import { UserInfo } from './user';
export interface AuthItem {
  url: string;
  type: number;
  plid: string;
  name: string;
  lid: string;
  menu_name: string;
  child_menu: AuthItem[];
}

export enum IsFirstLoginEnum {
  HIDE,
  SHOW
}

export enum IsFirstUseEnum {
  UN_FIRST_USE,
  FIRST_USE
}

export enum ShowMyClassMenuEnum {
  HIDE,
  SHOW
}

export enum ShowPhoneEyeEnum {
  HIDE,
  SHOW
}

export interface AuthType {
  detail_menus: AuthItem[];
  is_first_login: IsFirstLoginEnum;
  is_first_use: IsFirstUseEnum;
  show_myclass_menu: ShowMyClassMenuEnum;
  show_phone_eye: ShowPhoneEyeEnum;
}

export const ROLE = {
  HAVE: 1,
  NONE: 0
} as const;
export interface RoleListItemType {
  roleLid: string;
  roleName: string;
}
export interface RoleListType {
  roleList: RoleListItemType[];
}

export interface SetRoleType {
  workcode_id: string;
  teacher_id: number;
  role_lid: string;
}

export type Token = {
  token: string;
};

export type ReqParam = {
  token: string;
};

export type ResCurrentUser = Pick<UserInfo, 'account' | 'email' | 'name' | 'teacherId' | 'workcode' | 'account_name' | 'role_id'>;

export const MENU_LIST = 'menu_list';
/**
 * 用户没有角色
 */
export const NO_ROLE = 1009;

/**
 * 需要展示欢迎页
 */
export const SHOW_WELCOME = 1;
